import queryKeys from '../hooks/queryKeys';

const updateCommentInQueryData = (queryClient, comment) => {
  const { entityType, entityId } = comment;
  const queryKey = queryKeys.comments(entityType, entityId);
  queryClient.setQueryData(queryKey, (data) => {
    if (!data) return data;
    return {
      ...data,
      comments: (data.comments || []).map((c) =>
        c.id === comment.id ? { ...c, ...comment } : c
      ),
    };
  });
};

export default updateCommentInQueryData;
